import Reading from './Reading';

export default Reading;
